import React, { Component } from 'react';
import './index.scss';

const guideList = [
    {
        id: 1,
        title: '注册/登录账号',
        color: '#FF6A6A',
        content: `<p>按你当前端（App / 小程序等）页面提示完成登录并勾选协议。各端登录入口可能不同，帮助中心不列举具体方式，以免与你手头的端不一致。</p><p>未注册过的手机号登录后，会自动注册为新账号。换号请到【我的】自行修改手机号，避免再开一个新账号，导致余额、交易等在旧账号。</p>`
    },
    {
        id: 2,
        title: '绑定学校（项目）',
        color: '#FF9052',
        content: `<p>通过扫设备二维码、蓝牙搜索设备、卡物理ID等方式绑定学校（以页面按钮为准）。</p><p>仔细核对学校名称再绑；绑错学校需先删除学校再重新绑定。</p><p>不绑定则通常无法使用本校设备。</p>`
    },
];

class BeginnerGuide extends Component {
    componentDidMount() {
        document.title = '新手指南';
    }

    render() {
        return (
            <div className="beginner-guide-container">
                <div className="guide-content">
                    {guideList.map(item => (
                        <div className="guide-item" key={item.id}>
                            <div className="guide-item-header">
                                <span className="guide-badge" style={{ backgroundColor: item.color }}>
                                    {item.id}
                                </span>
                                <span className="guide-title">{item.title}</span>
                            </div>
                            <div className="guide-item-body" dangerouslySetInnerHTML={{ __html: item.content }} />
                        </div>
                    ))}
                </div>
            </div>
        );
    }
}

export default BeginnerGuide;
